module.exports = __webpack_public_path__ + "img/P31-zh.26a3ee42.png";